export default __webpack_public_path__ + "static/media/icon-eye-closed.5bc11f16.svg";